import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Shield, Loader2 } from 'lucide-react';
import { useGetLegalPageQuery } from '@nimbazaar/store';

export function PrivacyPolicy() {
  const { data, isLoading } = useGetLegalPageQuery('privacy-policy');
  const page = data?.data;
  const title = page?.title || 'Privacy Policy';
  const content = page?.content || '';
  const updatedAt = page?.updatedAt;

  useEffect(() => {
    document.title = `${title} - NimBazaar`;
  }, [title]);

  return (
    <div className="min-h-screen bg-gradient-to-b from-primary-50/50 to-white">
      {/* Header */}
      <div className="bg-gradient-to-r from-primary-800 to-primary-900 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10 sm:py-14">
          <Link to="/" className="inline-flex items-center gap-1.5 text-sm text-primary-200 hover:text-white mb-6 transition-colors">
            <ArrowLeft className="w-4 h-4" />
            Back to Home
          </Link>
          <div className="flex items-center gap-4">
            <div className="w-14 h-14 rounded-2xl bg-white/10 backdrop-blur flex items-center justify-center">
              <Shield className="w-7 h-7 text-secondary-400" />
            </div>
            <div>
              <h1 className="text-2xl sm:text-3xl font-bold">{title}</h1>
              {updatedAt && (
                <p className="text-sm text-primary-200 mt-1">
                  Last updated: {new Date(updatedAt).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
                </p>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-6 sm:py-10">
        {isLoading ? (
          <div className="flex items-center justify-center py-20 text-gray-400">
            <Loader2 className="w-6 h-6 animate-spin mr-2" />
            Loading...
          </div>
        ) : content ? (
          <div
            className="bg-white rounded-2xl shadow-sm border border-gray-100 p-4 sm:p-6 lg:p-8"
            dangerouslySetInnerHTML={{ __html: content }}
          />
        ) : (
          <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-10 text-center text-gray-400">
            Content coming soon.
          </div>
        )}
      </div>
    </div>
  );
}
